import {PostApiMethod} from "./ApiMethod";

// 注意，此时的 postUrl 为列表形式，此为新增、编辑通用方法
const OnFinishMethod = (data, postUrl) => {
    // console.log("postData  ", data)
    if (postUrl.length > 1) {
        let index = 0;
        let intervalId = setInterval(() => {
            // 当将数据写入多个数据库时， dataIndex 保证只显示最后一条成功消息
            PostApiMethod(postUrl[index], {...data, dataIndex: (index + 1) / postUrl.length});
            index++;
            if (index >= postUrl.length) {
                clearInterval(intervalId);
            }
        }, 1000)
    } else {
        // 当向同一个数据库批量导入多条数据时， dataIndex 保证只显示最后一条成功消息
        PostApiMethod(postUrl[0], data);
    }
}

export default OnFinishMethod;